function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2012(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.73,
    height: 7.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.768
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 3.84
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.68,
    width: 15.73,
    height: 8.81,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4683333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 12.085
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.48,
    width: 15.73,
    height: 8.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 20.975
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.48,
    width: 15.73,
    height: 9.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.352857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 30.215
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.95,
    width: 15.73,
    height: 10.65,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.33125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 40.275000000000006
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.6,
    width: 15.73,
    height: 11.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 51.19
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.78,
    width: 15.73,
    height: 11.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9153846153846155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 62.730000000000004
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68.68,
    width: 15.73,
    height: 12.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 75.02000000000001
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 81.36,
    width: 15.73,
    height: 13.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3283333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 88.345
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95.33,
    width: 15.73,
    height: 16.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2471428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 103.605
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.88,
    width: 15.73,
    height: 17.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2471428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 120.50999999999999
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 129.14,
    width: 15.73,
    height: 17.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2471428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 137.86499999999998
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146.58,
    width: 15.73,
    height: 19.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 156.50500000000002
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 166.43,
    width: 15.73,
    height: 20.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 176.5
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 186.58,
    width: 15.73,
    height: 21.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 197.54500000000002
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 208.51,
    width: 15.73,
    height: 22.16,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 219.59
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 230.67,
    width: 15.73,
    height: 23.17,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 242.255
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.84,
    width: 15.73,
    height: 23.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 265.71
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.58,
    width: 15.73,
    height: 24.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 289.775
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 301.97,
    width: 15.73,
    height: 24.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 314.45500000000004
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 326.94,
    width: 15.73,
    height: 25.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 339.61
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 352.28,
    width: 15.73,
    height: 27.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2471428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 365.80499999999995
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 379.33,
    width: 15.73,
    height: 27.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 393.25
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 407.17,
    width: 15.73,
    height: 28.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2471428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 421.245
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 435.32,
    width: 15.73,
    height: 28.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 449.43
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 463.54,
    width: 15.73,
    height: 28.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 477.75
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 491.96,
    width: 15.73,
    height: 28.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6216666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 506.17499999999995
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 520.39,
    width: 15.73,
    height: 29.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2471428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 535.0749999999999
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 549.76,
    width: 15.73,
    height: 29.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 564.5649999999999
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.37,
    width: 15.73,
    height: 30.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 594.375
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 609.38,
    width: 15.73,
    height: 30.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2471428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 624.43
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 639.48,
    width: 15.73,
    height: 30.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 654.535
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 669.59,
    width: 15.73,
    height: 30.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.865,
    y: 684.7950000000001
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 0,
    width: 19.63,
    height: 24.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9629999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 25.545,
    y: 12.245
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.36,
    y: 0,
    width: 20.15,
    height: 24.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.029999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.435,
    y: 12.245
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.51,
    y: 0,
    width: 20.94,
    height: 24.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9914285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.98,
    y: 12.245
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.44,
    y: 0,
    width: 21.39,
    height: 24.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2780000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.13499999999999,
    y: 12.245
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.83,
    y: 0,
    width: 21.52,
    height: 24.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5866666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.59,
    y: 12.245
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.35,
    y: 0,
    width: 22.02,
    height: 24.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.404
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.35999999999999,
    y: 12.245
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.37,
    y: 0,
    width: 22.21,
    height: 24.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.172857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.475,
    y: 12.245
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.58,
    y: 0,
    width: 22.56,
    height: 24.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.222857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.86,
    y: 12.245
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.14,
    y: 0,
    width: 22.68,
    height: 24.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2399999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.48,
    y: 12.245
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.82,
    y: 0,
    width: 22.81,
    height: 24.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5344444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.225,
    y: 12.245
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.62,
    y: 0,
    width: 24.39,
    height: 24.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.815,
    y: 12.245
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.02,
    y: 0,
    width: 24.5,
    height: 24.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.27,
    y: 12.245
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.51,
    y: 0,
    width: 25.18,
    height: 24.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.09999999999997,
    y: 12.245
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.7,
    y: 0,
    width: 26.33,
    height: 24.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.865,
    y: 12.245
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.03,
    y: 0,
    width: 27.33,
    height: 24.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.449
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.695,
    y: 12.245
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.36,
    y: 0,
    width: 27.43,
    height: 24.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.075,
    y: 12.245
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.79,
    y: 0,
    width: 30.56,
    height: 24.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.07,
    y: 12.245
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.35,
    y: 0,
    width: 30.82,
    height: 24.49,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.76000000000005,
    y: 12.245
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.17,
    y: 0,
    width: 30.92,
    height: 24.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.63,
    y: 12.245
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.09,
    y: 0,
    width: 30.93,
    height: 24.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.081666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.55499999999995,
    y: 12.245
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.02,
    y: 0,
    width: 30.95,
    height: 24.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.495,
    y: 12.245
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.97,
    y: 0,
    width: 31.28,
    height: 24.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.498571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.61,
    y: 12.245
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.25,
    y: 0,
    width: 31.76,
    height: 24.49,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.13,
    y: 12.245
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.01,
    y: 0,
    width: 31.86,
    height: 24.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.498571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.9399999999999,
    y: 12.245
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.87,
    y: 0,
    width: 31.96,
    height: 24.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.85,
    y: 12.245
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.83,
    y: 0,
    width: 32.17,
    height: 24.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.449
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.9150000000001,
    y: 12.245
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 24.49,
    width: 30.33,
    height: 26.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 37.62
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 50.76,
    width: 30.33,
    height: 27.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 64.56
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 78.36,
    width: 30.33,
    height: 27.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.653333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 92.32
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 106.27,
    width: 30.33,
    height: 28.33,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.721666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 120.435
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 134.61,
    width: 30.33,
    height: 29.32,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.188571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 149.27
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 163.93,
    width: 30.33,
    height: 30.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 179.02
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 194.1,
    width: 30.33,
    height: 30.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 209.39499999999998
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 224.69,
    width: 30.33,
    height: 30.86,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 240.12
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 255.55,
    width: 30.33,
    height: 31.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 271.28000000000003
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 287.01,
    width: 30.33,
    height: 32.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 303.03499999999997
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 319.06,
    width: 30.33,
    height: 32.15,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.79125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 335.135
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 351.21,
    width: 30.33,
    height: 32.53,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3699999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 367.47499999999997
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 383.73,
    width: 30.33,
    height: 33.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.332857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 400.45000000000005
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 417.17,
    width: 30.33,
    height: 33.64,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 433.99
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 450.81,
    width: 30.33,
    height: 33.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 467.665
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 484.52,
    width: 30.33,
    height: 34.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.79125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 501.635
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 518.75,
    width: 30.33,
    height: 34.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 535.96
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 553.17,
    width: 30.33,
    height: 34.87,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.066
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 570.6049999999999
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 588.04,
    width: 30.33,
    height: 36.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.033
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 606.26
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 624.48,
    width: 30.33,
    height: 37.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 643.165
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.73,
    y: 661.85,
    width: 30.33,
    height: 38.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.895,
    y: 680.9250000000001
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 24.49,
    width: 33.29,
    height: 34.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3289999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.705,
    y: 41.955
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.35,
    y: 24.49,
    width: 33.59,
    height: 34.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.598333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.145,
    y: 41.955
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 24.49,
    width: 33.74,
    height: 34.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.748
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.8,
    y: 41.955
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.67,
    y: 24.49,
    width: 33.79,
    height: 34.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.565,
    y: 41.955
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.46,
    y: 24.49,
    width: 34.2,
    height: 34.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.56,
    y: 41.955
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.66,
    y: 24.49,
    width: 34.22,
    height: 34.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.76999999999998,
    y: 41.955
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.88,
    y: 24.49,
    width: 34.48,
    height: 34.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.12,
    y: 41.955
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.36,
    y: 24.49,
    width: 35.15,
    height: 34.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.935,
    y: 41.955
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.51,
    y: 24.49,
    width: 36.11,
    height: 34.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.821666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.565,
    y: 41.955
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.62,
    y: 24.49,
    width: 36.84,
    height: 34.93,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.821666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.04,
    y: 41.955
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.46,
    y: 24.49,
    width: 36.93,
    height: 34.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.92499999999995,
    y: 41.955
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.39,
    y: 24.49,
    width: 37.35,
    height: 34.93,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.36625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.065,
    y: 41.955
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.74,
    y: 24.49,
    width: 37.69,
    height: 34.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.58500000000004,
    y: 41.955
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.43,
    y: 24.49,
    width: 37.77,
    height: 34.93,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.315,
    y: 41.955
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.2,
    y: 24.49,
    width: 39.3,
    height: 34.93,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.85,
    y: 41.955
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.49,
    y: 24.49,
    width: 39.67,
    height: 34.93,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.821666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.325,
    y: 41.955
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.17,
    y: 24.49,
    width: 39.87,
    height: 34.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.1049999999999,
    y: 41.955
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.04,
    y: 24.49,
    width: 39.96,
    height: 34.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.02,
    y: 41.955
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 59.42,
    width: 40.68,
    height: 34.69,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.781666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 76.765
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 94.12,
    width: 40.68,
    height: 34.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.952
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 111.5
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 128.88,
    width: 40.68,
    height: 35.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 146.66
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 164.44,
    width: 40.68,
    height: 36.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 182.71
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 200.98,
    width: 40.68,
    height: 36.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 219.39999999999998
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 237.83,
    width: 40.68,
    height: 37.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 256.505
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 275.18,
    width: 40.68,
    height: 37.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.316666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 294.13
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 313.08,
    width: 40.68,
    height: 39.15,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5928571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 332.655
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 352.23,
    width: 40.68,
    height: 41.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 372.8
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 393.37,
    width: 40.68,
    height: 41.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 414.14
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 434.9,
    width: 40.68,
    height: 42.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 455.92999999999995
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 476.96,
    width: 40.68,
    height: 42.07,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 497.995
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 519.03,
    width: 40.68,
    height: 42.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 540.515
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 562,
    width: 40.68,
    height: 44.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 584.305
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 606.62,
    width: 40.68,
    height: 45.24,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 629.24
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.06,
    y: 651.85,
    width: 40.68,
    height: 48.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.4,
    y: 675.9250000000001
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 59.42,
    width: 41.65,
    height: 48.75,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.565,
    y: 83.795
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.39,
    y: 59.42,
    width: 41.84,
    height: 48.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.977142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.31,
    y: 83.795
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.23,
    y: 59.42,
    width: 43.56,
    height: 48.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.260000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.01,
    y: 83.795
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.79,
    y: 59.42,
    width: 45.93,
    height: 48.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.755,
    y: 83.795
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.72,
    y: 59.42,
    width: 46.42,
    height: 48.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.736666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.93,
    y: 83.795
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.14,
    y: 59.42,
    width: 48.84,
    height: 48.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.56,
    y: 83.795
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.98,
    y: 59.42,
    width: 50.51,
    height: 48.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.964285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.235,
    y: 83.795
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.49,
    y: 59.42,
    width: 53.63,
    height: 48.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.305,
    y: 83.795
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.12,
    y: 59.42,
    width: 56.57,
    height: 48.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.40500000000003,
    y: 83.795
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.69,
    y: 59.42,
    width: 61.07,
    height: 48.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.964285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.225,
    y: 83.795
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.75,
    y: 59.42,
    width: 61.18,
    height: 48.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.964285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.34,
    y: 83.795
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.94,
    y: 59.42,
    width: 62.06,
    height: 48.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.964285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.97,
    y: 83.795
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 108.18,
    width: 59.48,
    height: 52.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.62375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 134.675
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 161.17,
    width: 59.48,
    height: 53.26,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.876666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 187.79999999999998
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 214.43,
    width: 59.48,
    height: 54.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 241.54500000000002
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 268.66,
    width: 59.48,
    height: 56.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.315555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 297.08000000000004
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 325.51,
    width: 59.48,
    height: 69.4,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.895999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 360.21
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 394.91,
    width: 59.48,
    height: 69.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.895999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 429.89000000000004
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 464.87,
    width: 59.48,
    height: 75.66,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.913333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 502.7
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 540.54,
    width: 59.48,
    height: 79.42,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.913333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 580.25
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 619.95,
    width: 59.48,
    height: 80.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.608888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.47999999999999,
    y: 659.975
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 108.18,
    width: 67.3,
    height: 71.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.4125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.87,
    y: 143.72
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.52,
    y: 108.18,
    width: 69.18,
    height: 71.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.882857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.11,
    y: 143.72
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.7,
    y: 108.18,
    width: 71.46,
    height: 71.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.846666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.43,
    y: 143.72
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.16,
    y: 108.18,
    width: 73.5,
    height: 71.08,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.154285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.91,
    y: 143.72
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.66,
    y: 108.18,
    width: 76.39,
    height: 71.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.846666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.855,
    y: 143.72
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.05,
    y: 108.18,
    width: 97.68,
    height: 71.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.154285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.89,
    y: 143.72
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.72,
    y: 108.18,
    width: 98.28,
    height: 71.08,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.846666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.86,
    y: 143.72
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 179.26,
    width: 86.64,
    height: 83.27,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.40875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.54,
    y: 220.89499999999998
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 262.54,
    width: 86.64,
    height: 84.19,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.54,
    y: 304.635
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 346.73,
    width: 86.64,
    height: 84.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.141428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.54,
    y: 389.225
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 431.71,
    width: 86.64,
    height: 85.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.68625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.54,
    y: 474.455
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 517.2,
    width: 86.64,
    height: 89.02,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.54,
    y: 561.71
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.22,
    y: 606.22,
    width: 86.64,
    height: 93.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.54,
    y: 653.11
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.86,
    y: 179.26,
    width: 78.74,
    height: 112.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.23,
    y: 235.56
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.59,
    y: 179.26,
    width: 88.16,
    height: 112.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.66999999999996,
    y: 235.56
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.75,
    y: 179.26,
    width: 91.19,
    height: 112.6,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.345,
    y: 235.56
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.94,
    y: 179.26,
    width: 101.91,
    height: 112.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.381999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.895,
    y: 235.56
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.85,
    y: 179.26,
    width: 107.15,
    height: 112.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.307142857142859
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.4250000000001,
    y: 235.56
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.86,
    y: 291.87,
    width: 155.02,
    height: 79.62,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.9525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.37,
    y: 331.68
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.86,
    y: 371.48,
    width: 155.02,
    height: 88.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.572857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.37,
    y: 415.485
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.86,
    y: 459.5,
    width: 155.02,
    height: 240.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.37,
    y: 579.75
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.87,
    y: 291.87,
    width: 155.06,
    height: 248.12,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.843333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.4,
    y: 415.93
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.93,
    y: 291.87,
    width: 157.07,
    height: 248.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.4649999999999,
    y: 415.93
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.87,
    y: 539.99,
    width: 312.13,
    height: 160.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.935,
    y: 619.995
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2012);
export default __webpack_public_path__ + "static/media/2012.28e60036f3117492d307c5881f84b88e.svg";
export { ForwardRef as ReactComponent };